import { IChatMessage } from './chat';
import { ITicket } from '@app/shared/models/ticket';
import { UserProfile } from './UserProfile';

export class FirebaseUserProfile {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    role: string;
    verificationCode: string;
    verified: boolean;

    constructor(source: UserProfile) {
        this.firstName = source.FirstName;
        this.lastName = source.LastName;
        this.email = source.Email;
        this.phone = source.Phone;
        this.role = source.Role;
        this.verificationCode = source.VerificationCode;
        this.verified = source.Verified;
    }
}

export class FirebaseChatUser {
    userID: string;
    fcmToken: string;
    firebaseID: string;
    lastName: string;
    firstName: string;
    joinedAt: object;
    phone: string;
    photo: string;
    tagLine: string;
}

/* export class FirebaseChatMessage {
    fromID: string;
    messageID: string;
    sentAt: object;
    message: string;
    deleted: false;
    type: number;
    deliveredAt: Map<string, string>;
    readAt: Map<string, string>;
} */

export class FirebaseOperationChat {
    id: string;
    chatID: string;
    createdAt: object;
    group: boolean;
    participantsCount: number;
    photo: string;
    title: string;
    users: FirebaseChatUser[] = [];
    messages: IChatMessage[] = [];

    constructor(source: ITicket) {
        this.chatID = `chat_${source.id}`;
        this.group = false;
        this.photo = '';
        this.title = 'Operation Chat ' + source.id;
        this.id = source.id;
    }
}

export class FirebaseUser implements FirebaseChatUser {
  userID: string;
  fcmToken: string;
  firebaseID: string;
  lastName: string;
  firstName: string;
  joinedAt: object;
  phone: string;
  photo: string;
  tagLine: string;
  isAnonymous: boolean;

  constructor(user: any) {
    this.userID = user.id;
    this.firebaseID = user.firebaseUid;
    this.fcmToken = '';
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.phone = user.phoneNumber;
    this.photo = '';
    this.tagLine = '';
    this.isAnonymous = user.isAnonymous;
  }
}
